import { useTranslation } from 'react-i18next';

import { Select } from '@/components/ui/daisy';
import Evaluation from '@/models/Evaluation';

type CoursePathEvaluationTemplateSelectProps = {
  templates: Evaluation[];
  selectedTemplateId?: number;
  disabled?: boolean;
  onChange: (templateId: number) => void;
};

export default function CoursePathEvaluationTemplateSelect({
  templates,
  selectedTemplateId,
  disabled,
  onChange,
}: CoursePathEvaluationTemplateSelectProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.evaluationsTab.coursePath',
  });

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = Number(event.target.value);
    if (!Number.isNaN(value)) onChange(value);
  };

  return (
    <Select.Fieldset label={t('templateSelectLabel')}>
      <Select
        value={selectedTemplateId ?? ''}
        onChange={handleChange}
        disabled={disabled}
        className="w-full"
        aria-label={t('templateSelectLabel')}
      >
        <Select.Option value="" disabled>
          {t('templateSelectPlaceholder')}
        </Select.Option>
        {templates.map(template => (
          <Select.Option key={template.id} value={template.id}>
            {template.name}
          </Select.Option>
        ))}
      </Select>
    </Select.Fieldset>
  );
}
